import gql from "graphql-tag";

const GET_MERCHANT_DETAILS = gql`
  query {
    getMerchantDetails {
      email
      businessName
      firstName
      lastName
      isVerified
      stripeAccountId
      balance {
        available
        pending
        currency
      }
      transactions {
        id
        ref
        amount
        customerRef
        description
        applicationFeeAmount
        createdAt
        currency
        paymentIntentId
        status
        customer {
          firstName
          lastName
          id
          phone
          email
        }
      }
      customers {
        firstName
        id
        phone
        lastName
        email
      }
      payouts {
        amount
        created
        currency
        arrival_date
        destination
        failure_balance_transaction
        failure_code
        failure_message
        status
        source_type
        type
      }
    }
  }
`;



const GET_CUSTOMERS = gql`
  query getAllCustomers {
    getAllCustomers {
      id
      email
      phone
      firstName
      lastName
    }
  }
`;

export { GET_MERCHANT_DETAILS, GET_CUSTOMERS };
